/* eslint-disable indent */
import styled, { createGlobalStyle, keyframes } from 'styled-components';

import Row from 'components/Layout/Row';

export const HeaderContainer = styled.nav`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 9009;
  background-color: #ffffff;
  padding: 9px 30px;
  border-bottom: 1px solid #ffffff;
  box-shadow: 0 0 2px 0 rgba(17, 13, 29, 0.26);
  height: 55px;

  .go-back-button {
    display: inline-block;
  }

  .comments-drawer-button {
    margin-right: 20px;

    svg {
      vertical-align: bottom !important;
      width: 17px;
      height: 17px;
    }
  }

  & > div > div {
    white-space: nowrap;
  }

  .project-sharing-button {
    font-size: 16px;
    color: ${({ theme: { colors } }) => colors.textHighlightColor};
    vertical-align: middle;

    &:hover {
      color: ${({ theme: { colors } }) => colors.textHighlightColorDark};
    }
  }

  .project-options-button {
    display: inline-block;
    margin-left: 15px;
    border-radius: 50%;
    padding: 4px;

    svg {
      fill: ${({ theme: { colors } }) => colors.lighterBlack};
    }

    &:focus,
    &:hover {
      position: relative;

      &::before {
        content: '';
        position: absolute;
        z-index: -1;
        top: -3px;
        left: -3px;
        height: 35px;
        width: 35px;
        background-color: ${({ theme: { colors } }) => colors.lightGrey};
        border-radius: 50%;
      }
    }
  }

  .add-project-button-container {
    position: relative;
    display: inline-block;
    vertical-align: middle;
  }

  button.close-upgrade-message {
    position: fixed;
    height: 100% !important;
    width: 100% !important;
    cursor: default;
  }

  .archived-pages {
    display: inline-block;
    vertical-align: middle;
    font-size: 13px;
    font-weight: 500;
    line-height: 19px;
    color: ${({ theme: { colors } }) => colors.textHighlightColor};
    padding: 5px 13px 6px;
    background-color: rgba(101, 82, 255, 0.09);
    border-radius: 30px;
    letter-spacing: 0.3px;
    margin-left: 10px;
  }

  .header-project-users {
    @media (max-width: 1200px) {
      display: none;
    }
  }

  .notifications-toggle {
    position: relative;

    svg {
      transition: fill 0.1s;
    }

    &.is-active,
    &:hover {
      &::before {
        content: '';
        position: absolute;
        z-index: -1;
        top: -9px;
        left: -8px;
        height: 39px;
        width: 39px;
        background-color: ${({ theme: { colors } }) => colors.lightGrey};
        border-radius: 50%;
      }
    }

    &.is-active {
      svg {
        fill: ${({ theme: { colors } }) => colors.black};
      }
    }

    &--dot {
      position: absolute;
      left: 10px;
      top: -8px;
      background-color: ${({ theme: { colors } }) => colors.red};
      border-radius: 50%;
      color: white;
      font-size: 12px;
      font-weight: 500;
      width: 18px;
      height: 18px;
      line-height: 1.5;

      &.plus {
        line-height: 1.6;
        font-size: 11px;
      }
    }
  }

  .projects-menu {
    position: absolute;
    z-index: 2;
    top: calc(100% + 10px);
    left: -10px;

    &.project-filter {
      &.active {
        overflow: auto;
        max-height: 245px;
      }

      li {
        button {
          text-align: left;
          max-width: 230px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }

  .team-link {
    vertical-align: middle;
    font-weight: 500;
    font-size: 16px;

    &--inactive {
      margin-left: 20px;
      color: ${({ theme: { colors } }) => colors.black};
    }
  }

  .profile-menu {
    display: inline-block;
    list-style: none;
    padding: 0;
    margin: 0;
    vertical-align: middle;

    li {
      display: inline-block;
      padding: 0;
      margin: 0 10px;

      a {
        color: ${({ theme: { colors } }) => colors.black};
        text-decoration: none;
        font-size: 16px;
        font-weight: 500;

        &.is-active {
          color: ${({ theme: { colors } }) => colors.textHighlightColor};
        }
      }
    }
  }

  .expand-triangle {
    width: 0;
    height: 0;
    margin-left: 4px;
    border-style: solid;
    border-width: 4px 3.75px 0 3.75px;
    border-color: #010fd1 transparent transparent transparent;
    opacity: 0.3;
  }

  .project-title {
    display: inline-block;
    font-weight: 600;
    font-size: 16px;
    vertical-align: middle;

    & > span:first-child {
      display: inline-block;
      max-width: 170px;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .project-access-tag {
    margin-right: 22.5px;
  }

  .trial-period {
    background-color: ${({ theme: { colors } }) => colors.orange};
    color: #ffffff;
    padding: 4px 9px;
  }
`;

export const Separator = styled.div`
  display: inline-block;
  height: 25px;
  width: 1px;
  background-color: ${({ theme: { colors } }) => colors.deepLightGrey};
  vertical-align: middle;
  margin: 0 20px 0 16px;
`;

export const MenuDropdown = styled.div`
  position: relative;
  display: inline-block;
  margin-left: 20px;
  vertical-align: middle;

  .dropdown-button {
    position: relative;
    border: 0;
    border-radius: 50%;
    height: 34px;
    width: 34px;
    padding: 5px;
    padding-top: 6px;
    text-transform: uppercase;
    vertical-align: middle;

    img {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      border-radius: 50%;
      height: 100%;
      width: 100%;
    }
  }

  .popup-wrapper {
    position: fixed;
    z-index: 1;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    height: 100vh;
    width: 100vw;
    cursor: default;
  }

  & > ul {
    position: absolute;
    z-index: 3;
    padding: 0;
    top: calc(100% + 10px);
    right: 4px;
    min-width: 150px;
    text-align: left;

    &.active {
      padding: 10px 0;

      li {
        padding: 5px 15px;
      }
    }

    & > li {
      padding: 0 15px;

      a,
      button {
        text-align: left;

        &:hover,
        &:focus {
          color: ${({ theme: { colors } }) => colors.textHighlightColor};
        }
      }
    }
  }
`;

const notificationAnimation = keyframes`
  from {
    opacity: 0;
    transform: scale(0.95);
  }

  to {
    opacity: 1;
    transform: scale(1);
  }
`;

export const NotificationsDropdown = styled.div`
  position: fixed;
  display: inline-block;
  right: 300px;
  top: 50px;
  background-color: #ffffff;
  z-index: 3;
  box-shadow: ${({ theme: { menuShadow } }) => menuShadow};
  max-height: 0;
  height: auto;
  pointer-events: none;
  overflow: hidden;
  transform: scale(0.95);
  text-align: left;
  opacity: 0;
  border-radius: 3px;
  transform-origin: right top;
  transition: all 0.1s;
  visibility: hidden;
  animation: ${notificationAnimation} 0.2s;

  &.is-active {
    max-height: calc(100vh - 100px);
    pointer-events: all;
    transition: all 0.2s;
    opacity: 1;
    transform: scale(1);
    visibility: visible;
  }

  .notifications-header {
    background-color: ${({ theme: { colors } }) => colors.grey2};
    height: 46px;
    text-align: left;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 13px 15px;
    border-bottom: 1px solid ${({ theme: { colors } }) => colors.deepLightGrey};

    & > span {
      font-size: 15px;
      font-weight: 500;
    }

    &.active {
      opacity: 1;
    }

    .project-filter-button {
      position: relative;
      margin-left: auto;
      background-color: #ffffff;
      padding: 5.5px 17px 5.5px 10px;
      font-size: 12px;
      border-radius: 4px;
      font-weight: 500;
      border: 1px solid ${({ theme: { colors } }) => colors.deepLightGrey};
      max-width: 150px;
      text-overflow: ellipsis;
      overflow: hidden;

      &:hover {
        border-color: ${({ theme: { colors } }) => colors.grey};
      }

      &::after {
        content: '';
        position: absolute;
        right: 5px;
        top: 11px;
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 4px 3.65px 0 3.65px;
        border-color: ${({ theme: { colors } }) => colors.black} transparent
          transparent transparent;
        opacity: 0.3;
      }
    }
  }

  ul {
    transition: inherit;
    padding: 0;
    list-style: none;
    margin: 0;
    min-width: 150px;
    width: 390px;
    white-space: normal;
    overflow: auto;
    max-height: calc(100vh - 145px);

    /* .notification-clear-all {
      position: absolute;
      top: 19px;
      right: 16px;
      opacity: 0.7;

      &:hover {
        opacity: 1;
      }
    } */

    & > li {
      position: relative;
      line-height: 1.3em;
      padding: 0;

      a {
        display: flex;
        font-size: 14px;
        line-height: 1.16;
        padding: 10px 13px;
        line-height: 1.5;

        &:hover {
          color: initial;
          background-color: ${({ theme: { colors } }) => colors.lightGrey};

          .notification-content {
            .notification-date {
              opacity: 0;
            }

            .notification-clear {
              opacity: 1;
            }
          }
        }

        &.is-unseen {
          background-color: ${({ theme: { colors } }) => colors.grey3};

          &:hover {
            background-color: ${({ theme: { colors } }) => colors.grey2};
          }
        }

        .notification-type-icon {
          min-width: 34px;
          margin-top: 3px;
          margin-right: 13px;
          fill: ${({ theme: { colors } }) => colors.blue} !important;
        }

        .notification-type-avatar {
          margin-top: 3px;
          margin-right: 13px;
          height: 34px;
          width: 34px;
          min-width: 34px;
          object-fit: cover;
          border-radius: 50%;
        }

        .notification-type-thumbnail {
          width: 62px;
          height: 62px;
          object-fit: cover;
          border-radius: 2px;
        }

        .notification-content {
          position: relative;
          width: 240px;
          margin-right: 10px;

          .notification-text {
            display: block;
            color: ${({ theme: { colors } }) => colors.black};
          }

          .notification-date {
            font-size: 12px;
            color: ${({ theme: { colors } }) => colors.lighterBlack};
            text-align: center;
          }

          .notification-clear {
            position: absolute;
            left: 0;
            bottom: 3px;
            font-size: 12px;
            z-index: 1;
            align-self: flex-start;
            color: ${({ theme: { colors } }) => colors.lighterBlack};
            opacity: 0;

            &:hover {
              color: ${({ theme: { colors } }) => colors.textHighlightColor};
            }
          }
        }
      }

      &.notifications-empty {
        padding: 100px 15px;
        text-align: center;
      }
    }
  }
`;

export const NotificationsDot = styled.span`
  position: absolute;
  left: 15px;
  top: 2px;
  background-color: ${({ theme: { colors } }) => colors.red};
  padding: 3px;
  border-radius: 30px;
`;

export const PageVersionsMenuList = styled.ul`
  position: absolute;
  z-index: 9009;
  top: 55px;
  left: 3px;
  list-style: none;
  margin: 0;
  padding: 10px 0;
  background-color: #ffffff;
  border-radius: 5px;
  min-width: 200px;
  text-align: center;
  box-shadow: ${({ theme: { menuShadow } }) => menuShadow};

  li {
    padding: 7px 15px;
    text-align: left;

    &:hover {
      background-color: ${({ theme: { colors } }) => colors.lightGrey};
    }

    &.active {
      button {
        color: ${({ theme: { colors } }) => colors.blue};
      }
    }
  }
`;

export const UpgradeMessage = styled(Row)`
  position: absolute;
  top: 37px;
  right: 15px;
  padding: 24px 15px 15px;
  width: 386px;
  background-color: #ffffff;
  box-shadow: ${({ theme: { menuShadow } }) => menuShadow};
  border-radius: 10px;
  z-index: 1;
  white-space: normal;
  text-align: left;

  & > button {
    position: absolute;
    top: 7px;
    right: 7px;

    svg {
      opacity: 0.7;
    }

    &:hover {
      svg {
        opacity: 1;
      }
    }
  }

  .column {
    margin-right: 0;

    &.first {
      max-width: 52px;
      margin-left: 5px;
    }

    &.second {
      max-width: calc(100% - 52px);
    }

    &.third {
      min-width: 100%;
      border-top: 1px solid ${({ theme: { colors } }) => colors.deepLightGrey};
      padding: 12px 20px;
      margin: 18px -15px 0;
    }
  }

  span {
    display: block;
    font-size: 13px;
    line-height: 19px;
    opacity: 0.7;

    &.bold {
      margin-bottom: 6px;
      font-size: 15px;
      opacity: 1;
    }
  }

  a {
    color: ${({ theme: { colors } }) => colors.textHighlightColor};
    text-decoration: none;
    border: 0;

    &:hover {
      color: ${({ theme: { colors } }) => colors.textHighlightColorDark};
    }

    &:focus {
      color: ${({ theme: { colors } }) => colors.textHighlightColorDark};
      text-decoration: underline;
    }
  }

  .cta {
    display: block;
    color: #f67c01;
    margin-top: 10px;
    font-weight: 500;
  }
`;

export const Feedback = styled.div`
  position: relative;
  display: inline-block;
  margin-left: 20px;
  vertical-align: middle;

  .popup-wrapper {
    position: fixed;
    z-index: 1;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    height: 100vh;
    width: 100vw;
  }

  .whatsnew-overlay,
  .keyboard-shortcuts-overlay {
    position: fixed;
    z-index: 9999;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    height: 100vh;
    width: 100vw;
    cursor: default;
  }

  & > ul {
    position: absolute;
    top: calc(100% + 10px);
    right: 4px;
    z-index: 3;

    & > li {
      a,
      button {
        span {
          pointer-events: none;
        }
      }
    }
  }

  textarea {
    &:focus {
      border-color: ${({ theme: { colors } }) => colors.blue};
    }
  }

  .popup-wrapper,
  .screenshot-wrapper {
    position: fixed;
    z-index: 1;
    cursor: default;
  }

  .screenshot-wrapper {
    background-color: rgba(0, 0, 0, 0.3);
    cursor: crosshair;

    span {
      position: absolute;
    }

    .selection {
      display: block;
      background-color: rgba(101, 82, 255, 0.11);
      border: 1px solid ${({ theme: { colors } }) => colors.blue};
    }

    .message {
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      white-space: nowrap;
      color: #ffffff;
      background-color: ${({ theme: { colors } }) => colors.black};
      padding: 7px 10px;
      border-radius: 4px;
    }
  }

  .dropdown-button {
    position: relative;
    border: 0;
    border-radius: 50%;
    height: 34px;
    width: 34px;
    padding: 2px;
    padding-top: 4px;
    text-transform: uppercase;
    vertical-align: middle;

    svg {
      fill: ${({ theme: { colors } }) => colors.deepLightGrey};
    }

    &:focus,
    &:hover {
      position: relative;

      &::before {
        content: '';
        position: absolute;
        z-index: -1;
        top: -1px;
        left: -2px;
        height: 39px;
        width: 39px;
        background-color: ${({ theme: { colors } }) => colors.lightGrey};
        border-radius: 50%;
      }
    }
  }

  .wrapper {
    position: absolute;
    z-index: -1;
    top: 40px;
    right: 0;
    width: 300px;
    background-color: ${({ theme: { colors } }) => colors.lightGrey};
    box-shadow: ${({ theme: { menuShadow } }) => menuShadow};
    border-radius: 6px;
    opacity: 0;
    text-align: left;
    overflow: hidden;
    transform: translateY(-3px) scale(0.98, 0.98);
    transition: all 0.1s;

    &,
    & * {
      pointer-events: none;
    }

    &.is-active {
      transform: translateY(0px) scale(1, 1);
      transition: all 0.25s;
      opacity: 1;
      z-index: 2;

      &,
      & * {
        pointer-events: all;
      }
    }

    .close-button {
      position: absolute;
      top: 5px;
      right: 10px;

      svg {
        opacity: 0.8;
      }

      &:hover {
        svg {
          opacity: 1;
        }
      }
    }

    .header {
      background-color: ${({ theme: { colors } }) => colors.darkBlue};
      padding: 9px 12px;
      color: #ffffff;
    }

    .submit-button {
      display: block;
      margin: 10px;
      width: calc(100% - 20px);
    }

    .body {
      position: relative;
      padding: 10px;
      height: 200px;
      overflow: auto;

      textarea {
        display: block;
        padding: 14px 12px;
        box-shadow: ${({ theme: { shadowCard } }) => shadowCard};
        min-height: 85px;
        resize: none;
      }

      .screenshot-button {
        display: block;
        margin-top: 10px;
        font-size: 12px;
        color: ${({ theme }) => theme.colors.textHighlightColor};

        svg {
          margin-right: 5px;
        }

        &:hover {
          opacity: 0.75;
        }
      }

      .message-image {
        position: relative;
        border-radius: 4px;
        border: 1px solid ${({ theme: { colors } }) => colors.deepLightGrey};
        margin-top: 10px;
        overflow: hidden;

        button {
          display: flex;
          justify-content: center;
          align-items: center;
          position: absolute;
          top: 8px;
          right: 8px;
          height: 25px;
          width: 25px;
          background-color: rgba(0, 0, 0, 0.8);
          opacity: 0;
          border-radius: 50%;

          svg {
            height: 14px;
            width: 14px;
          }

          &:hover {
            opacity: 0.7;
          }

          &:focus {
            opacity: 1;
          }
        }

        &:hover {
          button {
            opacity: 0.5;
          }
        }
      }
    }

    .sent {
      padding: 40px;
      height: 200px;

      p {
        white-space: normal;
        font-weight: 500;
      }
    }
  }
`;

export const DrawerBodyStyle = createGlobalStyle`
  body {
    position: fixed;
    inset: 0;
    overflow-y: scroll;
  }
`;

export const Drawer = styled.div`
  position: fixed;
  right: 0;
  top: 0;
  z-index: 10000;
  overflow: hidden;
  width: 300px;
  height: 100vh;
  background-color: ${({ theme }) => theme.colors.lightGrey};
  box-shadow: 0 0 2px 0 rgba(17, 13, 29, 0.26);
  transition: ${({ theme: { transition } }) => transition};
  will-change: transform;

  .drawer-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    max-height: 45px;
    padding: 15px;
    text-align: left;
    font-weight: 500;
    background-color: #fff;
    box-shadow: 0 0 2px 0 rgba(17, 13, 29, 0.26);
  }

  .drawer-content {
    height: calc(100vh - 45px);
    padding: 15px;
    text-align: left;
    overflow-y: auto;

    a {
      color: ${({ theme }) => `${theme.colors.textHighlightColor} !important`};

      &:focus,
      &:hover {
        color: ${({ theme }) =>
          `${theme.colors.textHighlightColorDark} !important`};
      }
    }

    .post-card {
      padding: 15px;
      min-height: 100px;
      background-color: #fff;
      box-shadow: 0 0 2px 0 rgba(17, 13, 29, 0.26);

      & + .post-card {
        margin-top: 15px;
      }

      .title {
        margin-top: 0;
        margin-bottom: 5px;
        font-weight: 600;
        font-size: 15px;
        white-space: normal;
      }

      .subhead {
        margin-top: 0;
        margin-bottom: 0;
        font-size: 12px;
        opacity: 0.6;
      }

      .content {
        * {
          font-size: 14px !important;
          line-height: 22px;
          white-space: normal !important;

          &:last-child {
            margin-bottom: 0;
          }
        }

        a {
          color: ${({ theme }) => theme.colors.blue};
          text-decoration: none;
        }
      }
    }

    ul {
      width: 100%;
      margin-top: 0;
      margin-bottom: 0;
      padding-left: 0;
      list-style: none;

      li {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        padding: 15px 0;
        line-height: 22px;

        &:first-child {
          padding-top: 0;
        }

        & + li {
          border-top: 1px solid ${({ theme }) => theme.colors.grey2};
        }

        span {
          display: inline-block;
          font-size: 13px;

          &:first-child {
            margin-right: 2px;
            font-weight: 500;
          }

          &:last-child {
            margin-left: 2px;
          }
        }

        code {
          padding: 2px;
          background-color: #fff;
          box-shadow: 0 0 2px 0 rgba(17, 13, 29, 0.26);
          white-space: nowrap;

          & + code {
            margin-left: 4px;
          }
        }
      }
    }
  }
`;

export const PowerUpContainer = styled.div`
  position: relative;
  display: inline-block;
  margin-right: 25px;

  .popup-wrapper {
    position: fixed;
    z-index: 1;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    height: 100vh;
    width: 100vw;
    cursor: default;
  }

  .powerup-toggle {
    position: relative;
    display: inline-block;
    vertical-align: middle;

    &.is-active,
    &:hover {
      &::before {
        content: '';
        position: absolute;
        z-index: -1;
        top: -7px;
        left: -8px;
        height: 39px;
        width: 39px;
        background-color: ${({ theme: { colors } }) => colors.lightGrey};
        border-radius: 50%;
      }
    }

    &.is-active {
      svg {
        fill: ${({ theme: { colors } }) => colors.yellow};
      }
    }
  }

  & > div {
    position: absolute;
    z-index: 3;
    background-color: #ffffff;
    padding: 0 18px;
    top: calc(100% + 15px);
    right: -4px;
    list-style: none;
    margin: 0;
    max-height: 0;
    height: auto;
    width: 170px;
    font-weight: 500;
    text-align: left;
    box-shadow: ${({ theme: { menuShadow } }) => menuShadow};
    border-radius: 3px;
    transition: all 0.05s;
    overflow: hidden;
    visibility: hidden;
    //border: 1px solid ${({ theme }) => theme.colors.deepLightGrey};

    &.active {
      transition: all 0.3s;
      max-height: 250px;
      padding: 18px;
      visibility: visible;
    }
  }
`;
